import BaseEvent from "./BaseEvent";
export default class StopEvent extends BaseEvent {
    constructor(beat, length, index) {
        super();
        this.BEAT = beat;
        this.LENGTH = length;
        this.PRIORITY = 1;
        this.INDEX = index;
    }
}
